import Head from 'next/head'
import Image from 'next/image';
import { useState, useEffect } from 'react';
import Slider from "react-slick";
import Link from 'next/link';
import Topbanner from '../../components/Reusable/Banner/Topbanner';
import { RidesAndActivitiesData } from '../../data/RidesAndActivitiesData';
import styles from "../../styles/Pages/RidesAndActivities.module.scss";
import Activitygallery from '../../components/Reusable/Activitygallery/Activitygallery';
import { BsFillPlayCircleFill } from 'react-icons/bs';
import ReactPlayer from 'react-player'
import Safety from '../../components/Heighlights/Heighlights';
import SafetyList from '../../components/Heighlights/SafetyList';
import { AncorSecoundaryButton } from '../../components/Reusable/Buttons/Buttons';

var $ = require("jquery");
if (typeof window !== "undefined") {
    window.$ = window.jQuery = require("jquery");
}

export default function Room({ attraction, allAttractions }) {
    const [filteredAttraction, setFilteredAttraction] = useState(allAttractions);
    let filteredArray = filteredAttraction.filter(item => item.slug !== attraction.slug);
    const activityVideoId = attraction.activityVideo;
    // console.log(activityVideoId);

    const similarAttractions = filteredArray;

    const settings = {
        infinite: true,
        arrows: true,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const Images = attraction.galleryImages;

    // useEffect(() => {
    //     function loadVideo() {
    //         window.YT.ready(function () {
    //             const youtubeplayer = new window.YT.Player("singleActivityPlayer", {
    //                 height: "100%",
    //                 width: "100%",
    //                 videoId: activityVideoId,
    //                 playerVars: { 'playsinline': 1, 'modestbranding': 1, 'autohide': 1, 'showinfo': 0, 'rel': 0, 'controls': 0 },
    //                 events: {
    //                     onReady: onPlayerReady,
    //                     onStateChange: onPlayerStateChange,
    //                 }
    //             });
    //         });

    //         function onPlayerReady(event) {
    //             event.target.playVideo();
    //             // Get video title and set as title attribute
    //             var playerTitle = event.target.getVideoData().title;
    //             var playerElement = document.getElementById("singleActivityPlayer");
    //             playerElement.setAttribute("title", playerTitle);
    //         }

    //         function onPlayerStateChange(event) {
    //             var videoStatuses = Object.entries(window.YT.PlayerState);
    //         }
    //     }

    //     $(document).ready(function () {
    //         $.getScript("https://www.youtube.com/iframe_api", function () {
    //             loadVideo();
    //         });
    //     });
    // }, []);

    // const roomamenities = room.amenities
    // const galleryImg = room.gallery

    const highlights = [
        {
            icon: "/icons/thrill.svg",
            title: "Thrill for Everyone",
            description: " Every one of our pilots have a valid license and possesses the knowledge, experience, and expertise required of someone with the skill level of a pilot. This includes having a complete comprehension of the factors that a pilot needs to be aware of in order to ensure the safety of the passengers."
        },
        {
            icon: "/icons/safety-first.svg",
            title: "Safety First, Thrills Second",
            description: "We have more than five years of expertise in the field of helicopter safari, during which time we have provided tourists with genuine and exciting adventures. Because of this, our pilots are highly trained professionals who are equipped with all of the necessary skills and information to ensure the safety of the passengers."
        },
        {
            icon: "/icons/family-star.svg",
            title: "Unforgettable Adventure",
            description: "More than five hundred individuals have been able to experience the thrill of one of our helicopter safaris up to this point. This helicopter safari was built from the ground up to provide the maximum amount of personal attention to each guest and to fulfill their every desire for an exciting trip."

        },
    ];

    return (
        <>
            <Head>
                <title>{attraction.metaTitle}</title>
                <meta name="description" content={attraction.metaDesc} />
                <meta name="keywords" content={attraction.metaKeywords} />
                <link rel="icon" href="/favicon.png" />
                <link rel="canonical" href={`https://www.adventureresortkufri.com/rides-and-activities/${attraction.slug}`} />
            </Head>
            <Topbanner title={attraction.title} bgImage={attraction.bannerImage} target="#firstsec" />

            {/* <Safety highlights={highlights} /> */}

            <section className={`${styles.single_attraction} common_padding`} id="firstsec">
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className={`${styles.single_attraction_content} col-md-8 common_title ride_activity_title`}>
                            <h2>{attraction.title}</h2>
                            {/* <Image src="/icons/line.svg" width={120} height={2} alt='Line Icon'></Image> */}
                            <p className='m-0'>{attraction.longDesc}</p>
                        </div>

                        {attraction?.activityVideo ?
                            <div className={`${styles.single_attraction_video} col-md-8`}>
                                <video width="100%" height="100%" controls loop autoPlay muted title='Go-Karting by Adventure Resort'>
                                    <source src="/video/go-karting.mp4" type="video/mp4" />
                                    <meta itemProp="uploadDate" content="2023-12-10" />
                                    <meta itemProp="thumbnailUrl" content="https://www.adventureresortkufri.com/images/activitiesimages/single-attrac-banner.png" />
                                    <track
                                        src="/path/to/captions.vtt"
                                        kind="subtitles"
                                        srcLang="en"
                                        label="English"
                                    />
                                </video>
                            </div>
                            : ''
                        }

                        <div className={`${styles.buy_ticket_btn} col-md-12 d-flex justify-content-center mt-4`}>
                            <AncorSecoundaryButton
                                redirectPage={'/tickets'}
                                className={'margin_0_auto'}
                                buttonText={'BUY TICKETS'} />
                        </div>


                        {/* <section className={`${styles.restaurant_sec} common_padding`}>
                            <div className='container'>
                                <div className={`${styles.restasurant_main} row align-items-center`}>
                                    <div className={`${styles.restaurnat_right} col-md-5 `}>
                                        <div className='common_title mobile_text_center'>
                                            <h2 className='subhead_animate'>{attraction.activity_title}</h2>
                                            <p>{attraction.activity_description}</p>
                                            <Link href='/restaurant' className='secoundary_btn'>Book Tickets Now</Link>
                                        </div>
                                    </div>
                                    <div className={`${styles.restaurnat_left} col-md-7`}>
                                        <Image src='/images/restaurant-main.png' alt='Restaurant Image' width={725} height={550}></Image>
                                    </div>
                                </div>
                            </div>
                        </section> */}

                        {/* {attraction.title === "Go-Karting" && <section>
                            <div className='col-md-8 text-center common_title ride_activity_title' style={{ margin: '0 auto' }}>
                                <h2 className='common_padding'>{attraction.activity_type_title}</h2>
                                <div className={`${styles.activity_type_container} d-flex`} style={{ margin: '0 auto', gap: '20px' }}>
                                    <div className={styles.activity_type_parent}>
                                        <div className={styles.activity_type_img}>
                                            <Image src={attraction.activity_type_one_img} fill={true}></Image>
                                        </div>
                                        <p>{attraction.activity_type_one_caption}</p>
                                    </div>
                                    <div className={styles.activity_type_parent}>
                                        <div className={styles.activity_type_img}>
                                            <Image src={attraction.activity_type_two_img} fill={true}></Image>
                                        </div>
                                        <p>{attraction.activity_type_two_caption}</p>
                                    </div>
                                </div>
                            </div>
                        </section>} */}
                    </div>
                </div>
            </section>

            {/* <SafetyList /> */}

            <Activitygallery key={attraction.slug} Images={Images} title={attraction.title} />

            {/* <section className={styles.similar_attraction}>
                <div className='container'>
                    <div className='text-center common_title'>
                        <h2>Similar Rides & Activites</h2>
                        <Image src="/icons/line.svg" width={120} height={2} alt='Line Icon'></Image>
                    </div>
                    <div className={styles.activities_slider}>
                        <Slider {...settings} className="activity_slider">
                            {similarAttractions.map((item, index) => (
                                <div className={`${styles.activity_child} common_title`} key={index}>
                                    <img src={item.bgImage} alt={item.title} />
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                    <Link className="secoundary_btn" href={`/rides-and-activities/${item.slug}`}>View More</Link>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section> */}


        </>
    )
}

export const getStaticProps = async ({ params }) => {
    const allAttractions = RidesAndActivitiesData
    const currentSlug = params.slug;
    const attraction = RidesAndActivitiesData.find((attraction) => attraction.slug === currentSlug) || {
        notfound: true,
    };
    return { props: { attraction, allAttractions } };
};

export const getStaticPaths = async () => {
    const paths = RidesAndActivitiesData.map((attraction) => ({
        params: { slug: attraction.slug },
    }));
    return { paths, fallback: false };
};
